import {
  apiCallWithAntiForgery,
  getInstance,
  getKeepzPostInstace,
  localToken,
} from ".";

// serviceType is number 1 is identomat 2 is creditInfo
export async function getAgreements(lang, serviceType) {
  return apiCallWithAntiForgery(
    "get",
    `Reference/GetAgreementTexts/${serviceType}/${lang}`
  );
}

export async function getAuthLink(lang, serviceType, userId = null) {
  const mobile = sessionStorage.getItem("mobile");

  return getInstance(localToken(), undefined).post(
    `Auth/GetAuthLink/${serviceType}/${lang}`,
    {
      mobile: mobile === "true",
      userId,
    }
  );
}

export async function startIdentOnboarding() {
  return getKeepzPostInstace().post(`onboarding/identomat/begin`, {});
}

export async function getMoneySecondSources() {
  return getInstance(localToken()).get(`/reference/GetMoneySecondSources`);
}

export async function getCompanyIncomeSources() {
  return getInstance(localToken()).get(`/reference/GetCompanyIncomeSources`);
}

export async function getStartupCapitalSources() {
  return getInstance(localToken()).get(`/reference/GetStartupCapitalSources`);
}

export async function getBanks() {
  return getInstance(localToken()).get(`/reference/GetBanks`);
}

export async function sendSessionToken(tokenId) {
  return apiCallWithAntiForgery("post", `Auth/GetResult/${tokenId}`, {
    data: "Post",
  });
}

export async function getPeps() {
  return getInstance(localToken()).get("/reference/GetPepTypes");
}

export async function getCities() {
  return getInstance(localToken()).get(`/reference/getcities`);
}

export async function GetPropertieSources() {
  return getInstance(localToken()).get(`/reference/GetPropertieSources`);
}

export async function getCountries() {
  return getInstance(localToken()).get(`reference/getcountries`);
}

export async function geCreditDebitCountries() {
  return getInstance(localToken()).get(`reference/getCreditDebitCountries`);
}

export async function GetSecondAgreementText(ServiceType, locale) {
  return getInstance(localToken()).get(
    `reference/GetSecondAgreementText/${ServiceType}/${locale}`
  );
}

export async function submitForm(payload) {
  return getInstance(localToken()).post(`/form/submitform`, payload);
}

export async function submitPIForm(payload) {
  return getKeepzPostInstace().post(`/form/submitformPI`, payload);
}

export async function verifyIdentity(payload) {
  return apiCallWithAntiForgery("post", `/onboarding/identity/verify`, payload);
}

export async function sendFiles(payload) {
  return getInstance(localToken()).post(`file/UploadFiles`, payload);
}

export async function sendSmsTanCode(lang) {
  return apiCallWithAntiForgery("post", `/form/SMSSend/${lang}`, {
    post: "Post",
  });
}

export async function getFullCountries() {
  return getInstance(localToken()).get(`reference/getfullcountries`);
}

export async function GetMonthlyTurnovers() {
  return getInstance(localToken()).get("/Reference/GetMonthlyTurnovers");
}
export async function getPepCategory() {
  return getInstance(localToken()).get("/Reference/GetPepCategory");
}
export async function getPurposes() {
  return getInstance(localToken()).get("/reference/GetAccountPurposes");
}
export async function getSecondAccountPurposes() {
  return getInstance(localToken()).get(`/reference/GetSecondAccountPurposes`);
}
const Services = {
  getAgreements,
  getAuthLink,
  sendSessionToken,
  getPeps,
  getCities,
  getCountries,
  geCreditDebitCountries,
  submitForm,
  sendSmsTanCode,
  GetSecondAgreementText,
  getFullCountries,
  GetMonthlyTurnovers,
  getPepCategory,
  getBanks,
  GetPropertieSources,
  getStartupCapitalSources,
  getCompanyIncomeSources,
  getSecondAccountPurposes,
  getMoneySecondSources,
  sendFiles,
  submitPIForm,
  verifyIdentity,
  startIdentOnboarding,
};

export default Services;
